import Modal from "components/layout/modal";
import { FunctionComponent, useEffect, useState } from "react";
import { ListUser } from "models/list-user";
import ArchivedUsersTable from "./archived-users-table";
import { adminDoGetArchivedListUsers } from "services/admin/list-user";
import { List } from "models/list";
import ArchivedUsersModalForm from "./archived-users-modal-form";
import Info from "components/info";
import Icon from "components/icon";
import { faPlus } from "components/icon-library";

interface ArchivedUsersModalProps {
  list: List;
  onSubmit: () => Promise<void>;
  onClose: () => Promise<void>;
}

const ArchivedUsersModal: FunctionComponent<ArchivedUsersModalProps> = ({
  list,
  onSubmit,
  onClose,
}) => {
  const [archivedUsers, toggleArchivedUsers] = useState<ListUser[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const users = await adminDoGetArchivedListUsers(list);
      toggleArchivedUsers(users);
    };
    fetch();
  }, []);

  const handleSubmit = async () => {
    await onSubmit();
    await onClose();
  };

  return (
    <Modal title="Tehtävänsä päättäneet ilmoitusvelvolliset">
      <Info>
        Voit aktivoida uudelleen tehtävänsä jo päättäneen ilmoitusvelvollisen
        painamalla <Icon icon={faPlus} /> ikonia ilmoitusvelvollisen kohdalta.
      </Info>
      <ArchivedUsersTable users={archivedUsers} onUpdate={handleSubmit} />
      <ArchivedUsersModalForm onClose={() => onClose()} />
    </Modal>
  );
};

export default ArchivedUsersModal;
